const notFound = () =>
  import ('@/mob/views/notFound')
const login = () =>
  import ('@/mob/views/user/login')
const findPass = () =>
  import ('@/mob/views/user/findPass')
const claim = () =>
  import ('@/mob/views/claimStoreList')
const claimStore = () =>
  import ('@/mob/views/claimStore')
const help = () =>
  import ('@/mob/views/help');
const aboutUs = () =>
  import ('@/mob/views/aboutUs');
const merchantAgreement = () =>
  import ('@/mob/views/merchantAgreement');
const userAgreement = () =>
  import ('@/mob/views/userAgreement');
const inviteAssistant = () =>
  import ('@/mob/views/inviteAssistant');




export default [{
    path: '/',
    redirect: '/claim'
  }, {
    path: '/login',
    name: 'login',
    component: login
  }, {
    path: '/claim',
    name: 'claim',
    component: claim
  }, {
    path: '/claim/:storeId',
    component: claimStore
  }, {
    path: '/help',
    name: 'help',
    component: help
  }, {
    path: '/aboutUs',
    name: 'aboutUs',
    component: aboutUs
  }, {
    path: '/agreement/admission',
    name: 'merchantAgreement',
    component: merchantAgreement
  }, {
    path: '/agreement/user',
    name: 'userAgreement',
    component: userAgreement
  }, {
    path: '/findPass',
    name: 'findPass',
    component: findPass
  },
  {
    path: '/notFound',
    name: 'notFound',
    component: notFound
  }, {
    path: '/invite-assistant',
    name: 'invite-assistant',
    component: inviteAssistant
  }
]



// WEBPACK FOOTER //
// ./src/router/mob/base.js